const packageJson = require('../../package.json')

module.exports = {
  version: packageJson.version,
  title: 'Atlas',
  baseUrl: 'https://manage.project-atlas.app',
  firebase: {
    apiKey: 'AIzaSyDzyTCzJCIdio9rTiF9XFwR04kjZY3ZXng',
    authDomain: 'project-atlas-8621c.firebaseapp.com',
    databaseURL: 'https://project-atlas-8621c.firebaseio.com',
    projectId: 'project-atlas-8621c',
    storageBucket: 'project-atlas-8621c.appspot.com',
    messagingSenderId: '713781402583'
  },
  cloudFunctions: 'https://us-central1-project-atlas-8621c.cloudfunctions.net',

  algolia: {
    appId: 'GFENHJU8CI',
    publicKey: '67a1ec9952cfb71fbac2dec430830c32'
  },
  contentful: {
    space: 'd1szh8uvr5lh',
    accessToken: 'yI62baPR6JWa2JLxvsvDIPvwDDtXBvtv7GzY11mjYEI'
  },
  sentry: 'https://ab055cad28ee4a92859925ecf86f6a22@sentry.io/208956',
  stripeApiKey: 'pk_test_wX9SITQSkiiguliVYP2QHC1300nWNfPuyA'
}
